import { useState, useEffect, FC } from 'react'
import {
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  SelectChangeEvent
} from '@mui/material'
import Cookies from 'js-cookie'
import { useGetLocationsOptionsQuery } from 'services/locations'

interface IGlobalLocationSelectProps {
  defaultLocationId?: string
  onLocationChange?: (locationId: string) => void
}

interface ILocation {
  id: string
  name: string
}

const GlobalLocationSelect: FC<IGlobalLocationSelectProps> = () => {
  const [selectedLocation, setSelectedLocation] = useState<string>(() => {
    return Cookies.get('selectedLocation') || 'all'
  })

  const { data, isLoading, isFetching } = useGetLocationsOptionsQuery({
    limit: 100,
    page: 1
  })
  const [locations, setLocations] = useState<
    Array<{ id: string; name: string }>
  >([])

  useEffect(() => {
    if (data?.locations) {
      const transformedLocations = data.locations.map(
        (location: ILocation) => ({
          id: location.id,
          name: location.name
        })
      )
      setLocations([{ id: 'all', name: 'All' }, ...transformedLocations])
    }
  }, [data])

  const handleLocationChange = (event: SelectChangeEvent<string>) => {
    const newLocationId = event.target.value
    setSelectedLocation(newLocationId)

    Cookies.set('selectedLocation', newLocationId)
    window.location.reload();
  }

  return (
    <FormControl fullWidth size="small">
      <InputLabel id="global-location-select-label">Location</InputLabel>
      <Select
        labelId="global-location-select-label"
        id="global-location-select"
        value={selectedLocation}
        onChange={handleLocationChange}
        label="Location"
        disabled={isLoading || isFetching}
      >
        {locations.map((location) => (
          <MenuItem key={location.id} value={location.id}>
            {location.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default GlobalLocationSelect
